<template>
  <component
    :is="as"
    :class="[
      'tw:inline-flex tw:items-center tw:rounded-full tw:border tw:font-medium',
      size === 'sm'
        ? 'tw:gap-1.5 tw:px-2 tw:py-0.5 tw:text-xs'
        : 'tw:gap-2 tw:px-3 tw:py-1.5 tw:text-sm',
      as === 'button' && 'tw:transition-colors tw:cursor-pointer',
      active
        ? 'tw:border-gray-800 tw:bg-gray-800 tw:text-white'
        : [
            'tw:border-gray-300 tw:bg-white tw:text-body',
            as === 'button' && 'tw:hover:bg-gray-100'
          ]
    ]"
    :title="title"
  >
    <span>{{ locale.label }}</span>
    <!-- The language the others are translated from, and the one participants fall back on. -->
    <span
      v-if="isDefault"
      :class="[
        'tw:rounded-full tw:px-1.5 tw:text-[0.65rem] tw:font-semibold tw:uppercase tw:leading-4 tw:tracking-wide',
        active ? 'tw:bg-white/20 tw:text-white' : 'tw:bg-gray-100 tw:text-gray-600'
      ]"
    >{{ $t('Default') }}</span>
    <span
      aria-hidden="true"
      :class="[
        'tw:inline-block tw:rounded-full',
        size === 'sm' ? 'tw:h-1.5 tw:w-1.5' : 'tw:h-2 tw:w-2',
        completed ? 'tw:bg-green-500' : 'tw:bg-gray-300'
      ]"
    />
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  locale: {
    type: Object,
    required: true
  },
  completed: {
    type: Boolean,
    default: false
  },
  active: {
    type: Boolean,
    default: false
  },
  isDefault: {
    type: Boolean,
    default: false
  },
  as: {
    type: String,
    default: 'span'
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md'].includes(value)
  }
})

const { t } = useI18n()

const title = computed(() => {
  const status = props.completed ? t('Translation filled in') : t('Translation missing')

  return props.isDefault ? `${t('Default language')} · ${status}` : status
})
</script>
